"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _menu = _interopRequireDefault(require("@/api/system/menu"));

var _IconSelect = _interopRequireDefault(require("@/components/IconSelect"));

var _vueTreeselect = _interopRequireWildcard(require("@riophae/vue-treeselect"));

require("@riophae/vue-treeselect/dist/vue-treeselect.css");

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _UD = _interopRequireDefault(require("@crud/UD.operation"));

var _DateRangePicker = _interopRequireDefault(require("@/components/DateRangePicker"));

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

// crud交由presenter持有
var defaultForm = {
  id: null,
  title: null,
  menuSort: 999,
  path: null,
  component: null,
  componentName: null,
  iframe: false,
  roles: [],
  pid: 0,
  icon: null,
  cache: false,
  hidden: false,
  type: 0,
  permission: null,
  versionNumber: null
};
var _default = {
  name: 'Menu',
  components: {
    Treeselect: _vueTreeselect.default,
    IconSelect: _IconSelect.default,
    crudOperation: _CRUD.default,
    rrOperation: _RR.default,
    udOperation: _UD.default,
    DateRangePicker: _DateRangePicker.default
  },
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '菜单',
      url: 'api/menus',
      crudMethod: _objectSpread({}, _menu.default)
    });
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  data: function data() {
    return {
      menus: [],
      permission: {
        add: ['admin', 'menu:add'],
        edit: ['admin', 'menu:edit'],
        del: ['admin', 'menu:del']
      },
      rules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        path: [{
          required: true,
          message: '请输入地址',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: (_methods = {}, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterToCU, function (crud, form) {
    this.menus = [];

    if (form.id != null) {
      if (form.pid === null) {
        form.pid = 0;
      }

      this.getSupDepts(form.id);
    } else {
      this.menus.push({
        id: 0,
        label: '顶级类目',
        children: null
      });
    }
  }), (0, _defineProperty2.default)(_methods, "getMenus", function getMenus(tree, treeNode, resolve) {
    var params = {
      pid: tree.id
    };
    setTimeout(function () {
      _menu.default.getMenus(params).then(function (res) {
        resolve(res.content);
      });
    }, 100);
  }), (0, _defineProperty2.default)(_methods, "getSupDepts", function getSupDepts(id) {
    var _this = this;

    _menu.default.getMenuSuperior(id).then(function (res) {
      var children = res.map(function (obj) {
        if (!obj.leaf && !obj.children) {
          obj.children = null;
        }

        return obj;
      });
      _this.menus = [{
        id: 0,
        label: '顶级类目',
        children: children
      }];
    });
  }), (0, _defineProperty2.default)(_methods, "loadMenus", function loadMenus(_ref) {
    var action = _ref.action,
        parentNode = _ref.parentNode,
        callback = _ref.callback;

    if (action === _vueTreeselect.LOAD_CHILDREN_OPTIONS) {
      _menu.default.getMenusTree(parentNode.id).then(function (res) {
        parentNode.children = res.map(function (obj) {
          if (!obj.leaf) {
            obj.children = null;
          }

          return obj;
        });
        setTimeout(function () {
          callback();
        }, 100);
      });
    }
  }), (0, _defineProperty2.default)(_methods, "selected", function selected(name) {
    this.form.icon = name;
  }), _methods)
};
exports.default = _default;